import menuLogo from "../Images/menu-logo.webp";
import orvaLogo from "../Images/orva-logo.webp";
import Troubleshoot from "../Images/Troubleshoot.webp";
import CernerLogo from "../Images/cerner-logo.webp";

const Images = {
  MenuLogo: menuLogo,
  OrvaLogo: orvaLogo,
  Troubleshoot: Troubleshoot,
  CernerLogo: CernerLogo,
};

export default Images;
